export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '6b974021-97d3-4e43-8df2-8f5d64a02e6b';
export const MODAL_CLOSE_SEC = 2.5;
